import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './PoliticaPrivacidade.css';

// API base URL based on environment
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_VERCEL_API_URL || 'https://api.veridicus.com.br'
  : process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:5000';

const PoliticaPrivacidade = () => {
  const [politica, setPolitica] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPolitica();
  }, []);

  const fetchPolitica = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/api/politica-privacidade/active`);
      
      if (response.data.success) {
        setPolitica(response.data.data);
      } else {
        setError('Nenhuma política de privacidade disponível no momento.');
      }
    } catch (error) {
      console.error('Erro ao buscar política de privacidade:', error);
      setError('Erro ao carregar a política de privacidade. Por favor, tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Carregando política de privacidade...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="error-container">
          <p className="error-message">{error}</p>
          <Link to="/" className="back-button">Voltar ao Início</Link>
        </div>
      );
    }

    if (!politica) {
      return (
        <div className="no-content-container">
          <p>Nenhuma política de privacidade disponível no momento.</p>
          <Link to="/" className="back-button">Voltar ao Início</Link>
        </div>
      );
    }

    return (
      <>
        <div className="politica-header">
          <h1>{politica.title}</h1>
          <div className="politica-meta">
            <span className="version">Versão {politica.version}</span>
            <span className="date">Última atualização: {formatDate(politica.updatedAt || politica.createdAt)}</span>
          </div>
        </div>
        
        <div 
          className="politica-content"
          dangerouslySetInnerHTML={{ __html: politica.content }}
        />
        
        <div className="politica-footer">
          <p className="info-text">
            Ao utilizar nossos serviços, você concorda com nossa política de privacidade.
          </p>
          <div className="action-buttons">
            <Link to="/" className="back-button">Voltar ao Início</Link>
            <button 
              onClick={() => window.print()} 
              className="print-button"
            >
              Imprimir
            </button>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Header />
      <div className="politica-page">
        <div className="politica-container">
          <nav className="breadcrumb">
            <Link to="/">Início</Link>
            <span className="separator">/</span>
            <span className="current">Política de Privacidade</span>
          </nav>
          
          {renderContent()}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PoliticaPrivacidade;